<template>
  <div id="modalDetailsResponsible" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Responsabilidades</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <div v-if="data.steps" class="table-responsive">
          <table class="table table-sm table-bordered table-striped">
            <thead class="table-primary">
              <tr>
                <th class="col-2">Atividade</th>
                <th
                  v-for="projectBidder in bidders"
                  :key="projectBidder.id"
                  class="text-center col-1"
                >
                  {{ projectBidder.bidderPartnerName }}
                </th>
                <th
                  v-for="projectPartner in partners"
                  :key="projectPartner.id"
                  class="text-center col-1"
                >
                  {{ projectPartner.bidderPartnerName }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="step in data.steps" :key="step.id">
                <td :title="step.description">
                  {{ step.order }} - {{ step.title }}
                </td>
                <td
                  v-for="responsibleBidder in step.responsibleBidders"
                  :key="responsibleBidder.id"
                  class="text-center"
                >
                  <span v-if="responsibleBidder.percent">
                    <small>{{ responsibleBidder.percent }}%</small>
                  </span>
                </td>
                <td
                  v-for="responsiblePartner in step.responsiblePartners"
                  :key="responsiblePartner.id"
                  class="text-center"
                >
                  <span v-if="responsiblePartner.percent">
                    <small>{{ responsiblePartner.percent }}%</small>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer border-top-0">
          <button
            type="button"
            class="btn btn-sm btn-link"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showModal } from '@/utils/modal'

export default {
  name: 'DetailsResponsibleModal',

  props: {
    projectId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      data: {},
      bidders: [],
      partners: [],
    }
  },

  methods: {
    async getProjectStepsResponsibles() {
      try {
        this.data = await this.$store.dispatch(
          'getProjectStepsResponsibles',
          this.projectId,
        )

        this.bidders = await this.$store.dispatch(
          'getProjectBidders',
          this.projectId,
        )

        this.partners = await this.$store.dispatch(
          'getProjectPartners',
          this.projectId,
        )

        showModal('modalDetailsResponsible')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },
  },

  mounted() {
    this.getProjectStepsResponsibles()
  },
}
</script>
